import { TabPanel } from '@reach/tabs'
import React, { useCallback, useRef } from 'react'
import Typography from '../Typography'
import * as Styled from './Tabs.styles'

const ContentWithTabs = ({ data, isVertical = false }) => {
  const tabsRef = useRef()

  const handleChange = useCallback(() => {
    if (isVertical && tabsRef.current) {
      tabsRef.current.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }, [isVertical])

  return (
    <Styled.Tabs
      ref={tabsRef}
      isVertical={isVertical}
      onChange={handleChange}
      className="leshen-content-with-tabs-wrapper"
    >
      <Styled.TabList isVertical={isVertical} className="tab-list">
        {data.map((tab) => (
          <Styled.Tab key={tab.title} isVertical={isVertical} className="tab">
            <Typography rendersAs="span" variant="feature" className="title">
              {tab.title}
            </Typography>
          </Styled.Tab>
        ))}
      </Styled.TabList>
      <Styled.TabPanels isVertical={isVertical} className="tab-panels">
        {data.map((tab) => (
          <TabPanel key={tab.title} className="tab-panel">
            {isVertical && (
              <Typography rendersAs="h3" variant="h4" className="title">
                {tab.title}
              </Typography>
            )}
            {tab.content}
          </TabPanel>
        ))}
      </Styled.TabPanels>
    </Styled.Tabs>
  )
}

export default ContentWithTabs
